import { CheckIcon } from "lucide-react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** KORI `.checkbox-box`: 18px, 1.5px strong hairline, ink fill and white check when on. */
function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer relative inline-grid size-[1.125rem] flex-none cursor-pointer place-content-center rounded-xs border-[1.5px] border-border-strong bg-surface-raised text-action-text",
        "transition-[background-color,border-color] duration-(--dur-fast) ease-(--ease-quiet)",
        "data-[state=checked]:border-action data-[state=checked]:bg-action data-[state=indeterminate]:border-action data-[state=indeterminate]:bg-action",
        "aria-invalid:border-danger disabled:cursor-not-allowed disabled:opacity-55",
        "before:absolute before:-inset-3 before:content-['']",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="grid place-content-center">
        {props.checked === "indeterminate" ? (
          <span className="block h-0.5 w-2 rounded-[1px] bg-action-text" />
        ) : (
          <CheckIcon className="size-3" strokeWidth={3} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
